import React, { Component } from 'react';
import PropTypes from 'prop-types';


import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';

const s:any = {
  master: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: 0,
    padding: 0,
    borderRadius: '15px 0 0 15px',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  },
  bannerbox:{
    height: 320,
    width: '100%',
    backgroundImage: 'url(lib/img/wcm2.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundColor: 'transparent',
    margin: 0,
    padding: 0,
    position: 'relative',
    borderRadius: '15px 0 0 0',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.1) 100%)',
      pointerEvents: 'none',
    },
  },
  messagebox:{
    width: '100%',
    background: 'linear-gradient(135deg, #1DACD6 0%, #24419B 100%)',
    margin: 0,
    padding: '40px 28px 32px 28px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
    minHeight: 220,
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '2px',
      background: 'linear-gradient(to right, transparent, rgba(255,255,255,0.4), transparent)',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '1px',
      background: 'rgba(255,255,255,0.1)',
    },
  },
  titlebar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    marginBottom: '16px',
    gap: '6px',
  },
  first: {
    color: '#FFD700',
    fontWeight: 700,
    fontSize: '1.875rem',
    letterSpacing: '-0.02em',
    lineHeight: 1.2,
    textShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  last: {
    color: '#FFFFFF',
    fontWeight: 600,
    fontSize: '1.875rem',
    letterSpacing: '-0.02em',
    lineHeight: 1.2,
    textShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  title: {
    color: '#FFD700',
  },
  subtitlebar: {
    marginBottom: '20px',
    paddingBottom: '12px',
    borderBottom: '1px solid rgba(255, 215, 0, 0.2)',
  },
  subtitle: {
    color: '#FFD700',
    fontWeight: 600,
    fontSize: '0.875rem',
    letterSpacing: '0.02em',
    opacity: 0.95,
    textTransform: 'uppercase',
  },
  messagebar: {
    marginTop: '4px',
  },
  message: {
    color: '#FFFFFF',
    fontSize: '0.9375rem',
    lineHeight: 1.7,
    fontWeight: 400,
    opacity: 0.92,
    letterSpacing: '0.01em',
  },
  textField: {
    marginLeft: 'spacing(1)',
    marginRight: 'spacing(1)',
  },
  hide:{
    display:'none',
  },
}

class LoginBanner extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      next: true,
      value: this.props.value 
    };
  }

  splitline = (line:string) => {
    const chunks = String(line).split(/\s+/);
    const [first,last] = [chunks.shift(), chunks.join(' ')];
    return {first,last};
  }

  render() {
    const {id,label,divider,item,classes } = this.props;
    const {first,last} = this.splitline(item.title);
    return (
      <Box sx={{...s.master}}>
        <Box 
          sx={{
            ...s.bannerbox,
            backgroundImage: `url(${item.photo})`,
            transition: 'opacity 0.5s ease-in-out',
          }}
        >
          {/* <!-- Left Panel --> */}
        </Box>
        <Box sx={{...s.messagebox}}>
          <Box sx={{...s.titlebar}}>
            <Typography sx={{...s.first}} variant="h5" component="h5">{first}</Typography>&nbsp;
            <Typography sx={{...s.last}} variant="h5" component="h5">{` ${last}`}</Typography>
          </Box>
          <Box sx={{...s.subtitlebar}}>
            <Typography sx={{...s.subtitle}} variant="subtitle1" component="span">{item.subtitle}</Typography>
          </Box>
          <Box sx={{...s.messagebar}}>
            <Typography sx={{...s.message}} variant="body1" component="div">{item.message}</Typography>
          </Box>
        </Box>
      </Box>
    );
  }
}

LoginBanner.propTypes = {
  classes: PropTypes.object.isRequired,
  //id: PropTypes.string.isRequired,
  //label: PropTypes.string.isRequired,
};

export default LoginBanner;
